import { useState } from 'react'
import { useGlobalContext } from '../context'

export default function Search() {

  const [text, setText] = useState('')
  const {setSearchTerm, fetchRandomMeal} = useGlobalContext()

  function handleChange(e) {
    setText(e.target.value)
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (text) {
      setSearchTerm(text)
      // setText('')
    }
  }

  function handleRandomMeal() {
    setSearchTerm('')
    setText('')
    fetchRandomMeal()
  }

  return (
    <header className='search-container'>
      <form onSubmit={handleSubmit}>
        <input
          type='text'
          placeholder='search meal'
          className='form-input'
          value={text}
          onChange={handleChange}
        />
        <button type='submit' className='btn'>Search</button>
        <button type='button' className='btn btn-hipster' onClick={handleRandomMeal}>Surprise me!</button>
      </form>
    </header>
  )
}
